import * as XLSX from "xlsx";
import { covertNumberToEn } from "./converNumberToEn";

const MOBILE_HEADER = /موبایل|همراه|تلفن|mobile|phone|cell/i;
const ARABIC_INDIC_DIGITS = /[٠-٩]/g;

const digitsOf = (value) => {
  if (value === null || value === undefined) return "";
  return covertNumberToEn(String(value))
    .replace(ARABIC_INDIC_DIGITS, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/\D/g, "");
};

export const toMobile = (value, allowWithoutLeadingZero) => {
  let digits = digitsOf(value);
  if (digits.startsWith("0098")) digits = `0${digits.slice(4)}`;
  else if (digits.length === 12 && digits.startsWith("98")) digits = `0${digits.slice(2)}`;
  if (/^09\d{9}$/.test(digits)) return digits;
  if (allowWithoutLeadingZero && /^9\d{9}$/.test(digits)) return `0${digits}`;
  return null;
};

const findMobileColumn = (rows) => {
  for (let r = 0; r < Math.min(rows.length, 10); r += 1) {
    const col = (rows[r] || []).findIndex(
      (cell) => typeof cell === "string" && MOBILE_HEADER.test(cell),
    );
    if (col !== -1) return { row: r, col };
  }
  return null;
};

export function extractMobilesFromWorkbook(data) {
  const workbook = XLSX.read(data, { type: "array", codepage: 65001 });
  const mobiles = new Set();
  let skipped = 0;

  workbook.SheetNames.forEach((name) => {
    const rows = XLSX.utils.sheet_to_json(workbook.Sheets[name], {
      header: 1,
      raw: true,
      defval: "",
    });
    const header = findMobileColumn(rows);

    if (header) {
      rows.slice(header.row + 1).forEach((row) => {
        const cell = row[header.col];
        if (cell === "" || cell === null || cell === undefined) return;
        const mobile = toMobile(cell, true);
        if (mobile) mobiles.add(mobile);
        else skipped += 1;
      });
      return;
    }

    rows.forEach((row) =>
      row.forEach((cell) => {
        const mobile = toMobile(cell, false);
        if (mobile) mobiles.add(mobile);
      }),
    );
  });

  return { mobiles: [...mobiles], skipped };
}

export function downloadMobileTemplate() {
  const sheet = XLSX.utils.aoa_to_sheet([
    ["شماره موبایل", "نام (اختیاری)"],
    ["09120000000", "نمونه"],
  ]);
  sheet["!cols"] = [{ wch: 18 }, { wch: 26 }];
  sheet["!views"] = [{ rightToLeft: true }];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, "لیست");
  XLSX.writeFile(workbook, "نمونه-لیست-نمایندگان-کمپین.xlsx");
}
